module.exports = __webpack_public_path__ + "img/slider-under-4.55af0adc.png";